module.exports = __webpack_public_path__ + "134744055a4a8218c8c0e0fbc94080f0.png";